import { useState } from "react";
import { atualizarReservaService } from "../../../services/atualizarReservaService";

export const usePagamentoProp = (reservaId: number | null, data: any) => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const resetError = () => setErrorMessage(null);

  const atualizar = async () => {
    setErrorMessage(null); // Resetando mensagem de erro antes de tentar novamente
    setIsLoading(true);
    let dataReserva = {};

    try {
      dataReserva = {
        statusReserva: "AGUARDANDO_PAGAMENTO_MC",
        dataPagamentoProprietario: data.dataPagamentoProprietario,
        valorPagamentoProp: data.valorPagamentoProp,
      };

      console.log(dataReserva);
      const atualizarReserva = await atualizarReservaService(
        reservaId,
        dataReserva
      );
      if (!atualizarReserva) {
        setErrorMessage(
          "Não foi possível confirmar o pagamento do proprietário. Tente novamente!"
        );
      } else {
        // Caso contrário, pode ser sucesso, se o retorno for esperado
        setSuccessMessage("Pagamento do proprietário confirmado com sucesso.");
      }
    } catch (error) {
      // Captura erros inesperados
      setErrorMessage(
        "Não foi possível confirmar o pagamento do proprietário. Tente novamente!"
      );
    } finally {
      setIsLoading(false); // Garantir que o loading seja removido ao final
    }
  };

  return { atualizar, isLoading, errorMessage, successMessage, resetError };
};
